import * as React from 'react';
import { FC } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { capitalize } from 'lodash-es';
import { useIntl } from 'react-intl';

import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { getDayPeriodKey } from 'utils/dateTime';

import { GreetingHeading, GreetingText } from './loyalty-greeting-widget.styled';

export enum GreetingVariant {
  TEXT,
  HEADING,
}

interface IGreetingWidgetProps {
  variant?: GreetingVariant;
  className?: string;
  dayPeriodEnabled?: boolean;
}

/**
 *
 * LoyaltyGreetingWidget shows a day based greeting to the loyaltyUser
 *
 */
const LoyaltyGreetingWidget: FC<IGreetingWidgetProps> = ({
  className,
  dayPeriodEnabled = true,
  variant = GreetingVariant.HEADING,
}: IGreetingWidgetProps) => {
  const { formatMessage } = useIntl();
  const { loyaltyUser } = useLoyaltyUser();
  const dayPeriod = getDayPeriodKey();
  const [firstName] = loyaltyUser?.name?.split(' ') || [];

  const greeting = dayPeriodEnabled
    ? formatMessage({ id: `greeting${capitalize(dayPeriod)}` }, { name: <span>{firstName}</span> })
    : formatMessage({ id: 'hiX' }, { name: <span>{firstName}</span> });

  const Wrapper = variant === GreetingVariant.HEADING ? GreetingHeading : GreetingText;

  return (
    <Wrapper className={className} data-private data-testid="greeting-widget">
      {greeting}
      <Icon icon="next" color="white" width="16px" aria-hidden />
    </Wrapper>
  );
};

export default LoyaltyGreetingWidget;
